import React from "react";
import PropTypes from "prop-types";
import { Link } from "../Link";
import { useTheme } from "../theme";

// TODO: Use translation string for "Read more"
export function ArticleBlurb({ className = "", title, summary, link = null }) {
    const { baseLineHeight, modularScale } = useTheme();
    return (
        <div className={`blurb ${className}`}>
            <h3 className="title override-global-styles">{title}</h3>
            <p className="summary">{summary}</p>
            {link && (
                <p className="link">
                    <Link to={link}>Read More</Link>
                </p>
            )}
            <style jsx>{`
                .title.override-global-styles {
                    font-size: ${modularScale(1)}em;
                    line-height: ${baseLineHeight / modularScale(1)};
                }
                .summary {
                    margin-top: 0.5em;
                    font-weight: 300;
                }
                .link {
                    margin-top: 0.75em;
                }
            `}</style>
        </div>
    );
}

ArticleBlurb.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
    link: PropTypes.string,
};

ArticleBlurb.defaultProps = {
    className: "",
    link: null,
};
